howspace.components.searchInput = (() => {
    'use strict';

    const dispatchSearchEvent = e => {
        howspace.dispatchEvent(e.target, howspace.components.searchInput.SEARCH, {
            value: e.target.value.trim()
        });
    };

    const checkClearSearchLabel = input => {
        const label = input.closest('.howspace-form-search-label');
        const clearSearchBtn = label.find('.clear-search-btn');

        if (input.val().trim() !== '') {
            label.addClass('show-clear-search-btn');
            clearSearchBtn.removeAttr('tabindex');
        } else {
            label.removeClass('show-clear-search-btn');
            clearSearchBtn.attr('tabindex', '-1');
        }
    };

    const handleInput = e => {
        const input = $(e.target);
        const debounce = input.attr('debounce') ?? 500;
        checkClearSearchLabel(input);

        if (input.data('search-timeout-id')) {
            clearTimeout(input.data('search-timeout-id'));
        }

        // If the event contains "originalEvent" it was triggered by user input. Otherwise,
        // the event was triggered programmatically, and we set timeout to zero.
        const timeout = e.originalEvent ? debounce : 0;
        input.data('search-timeout-id', setTimeout(() => {
            input.removeData('search-timeout-id');
            dispatchSearchEvent(e);
        }, timeout));
    }

    const handleKeyUp = e => {
        if (e.key === 'Escape') {
            // Clear search when user hits Escape.
            const input = $(e.target);
            input.next('.clear-search-btn').trigger('click');
        }
        if (e.key === 'Enter') {
            dispatchSearchEvent(e);
        }
    };

    const handlePaste = e => {
        const input = $(e.target);

        if (input.data('search-timeout-id')) {
            clearTimeout(input.data('search-timeout-id'));
        }

        // After paste the "input" event will trigger next. Let's stop listening that for a moment.
        input.off('input', handleInput);

        input.data('search-timeout-id', setTimeout(() => {
            // Continue listening for "input" event.
            input.on('input', handleInput);

            checkClearSearchLabel(input);
            input.removeData('search-timeout-id');
            dispatchSearchEvent(e);
        }, 0));
    };

    const clearSearch = e => {
        const btn = $(e.target);
        const label = btn.closest('.howspace-form-search-label');
        const input = label.find('.howspace-form-search-input');

        if (input.val().length === 0) {
            input.focus();
            return;
        }

        // Chrome can crash if this is done immediately. Let's wait for the next frame to avoid crashing.
        requestAnimationFrame(() => {
            input.val('').trigger('input')[0].focus();
        });
    };

    return {
        SEARCH: 'howspace-search',
        init: elem => {
            elem.findIncludingSelf('.howspace-form-search-label:not(.howspace-form-search-label-initialized)').each(function () {
                const searchLabel = $(this);
                searchLabel.addClass('howspace-form-search-label-initialized');

                const searchInput = searchLabel.find('.howspace-form-search-input');
                searchInput.on('input', handleInput);
                searchInput.on('paste', handlePaste);
                searchInput.on('keyup', handleKeyUp);
                searchLabel.find('.clear-search-btn').attr('tabindex', '-1').on('click', clearSearch);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-form-search-label.howspace-form-search-label-initialized').each(function () {
                const searchLabel = $(this);
                searchLabel.removeClass('howspace-form-search-label-initialized');

                const searchInput = searchLabel.find('.howspace-form-search-input');
                searchInput.off('input', handleInput);
                searchInput.off('paste', handlePaste);
                searchInput.off('keyup', handleKeyUp);
                searchLabel.find('.clear-search-btn').removeAttr('tabindex').off('click', clearSearch);
            });
        },
        clearSearch : input => {
            if (input instanceof jQuery) {
                input = input[0];
            }
            input?.closest('.howspace-form-search-label')?.querySelector('.clear-search-btn')?.click();
        }
    };

})();
